import { useCurrency } from '@providers/CurrencyProvider';
import type { FilterOptionListPriceType, FilterOptionType } from '@providers/FilterProvider';
import { FILTER_OPTION_TYPE, useFilterSettings } from '@providers/FilterProvider';
import { formatPriceLabel, roundAmount } from '@utils';
import { pick } from 'lodash-es';

import type { FilterOptionItemSettings } from '@/features/filter-product-list/filter/FilterOptionItem';
import type { FilterOptionListProps } from '@/features/filter-product-list/filter/FilterOptionList';
import FilterOptionList from '@/features/filter-product-list/filter/FilterOptionList';

export type FilterOptionPriceListProps = Omit<
  FilterOptionListProps<FilterOptionListPriceType>,
  'filterOptionItemProps'
>;

export const filterOptionItemSettings = (option: FilterOptionType): FilterOptionItemSettings => {
  const { filterType } = option;
  const optionItemSettings = pick(
    option,
    'prefix',
    'displayAllValuesInUppercaseForm',
    'selectType'
  );

  if (filterType === FILTER_OPTION_TYPE.PRICE || filterType === FILTER_OPTION_TYPE.VARIANTS_PRICE) {
    optionItemSettings.selectType = 'multiple';
  }

  return optionItemSettings;
};

const formatPriceValue = (to: number, from?: number) => {
  return `${from || ''}:${to || ''}`;
};

const FilterOptionPriceList = (props: FilterOptionPriceListProps) => {
  const { rateCurrency, unitCurrency } = useCurrency();
  const { precisionFormatLabelPriceList } = useFilterSettings();

  const itemSettings = filterOptionItemSettings(props.option);

  return (
    <FilterOptionList
      {...props}
      filterOptionItemProps={({ from, to, doc_count }) => {
        const fromFormat = roundAmount(from * rateCurrency, precisionFormatLabelPriceList);
        const toFormat = roundAmount(to * rateCurrency, precisionFormatLabelPriceList);
        return {
          value: formatPriceValue(to, from),
          label: formatPriceLabel(toFormat, fromFormat, unitCurrency),
          docCount: doc_count,
          settings: itemSettings,
        };
      }}
    />
  );
};

export default FilterOptionPriceList;
